import { Directive, EventEmitter, HostListener, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ExpertWorkspaceReferralInvitationDeepLinkDetailDialogComponent } from '@sprint-expert/app/modules/expert-workspace-referral-invitation-deep-link-detail/expert-workspace-referral-invitation-deep-link-detail-dialog.component';

@Directive({
  selector: '[appExpertWorkspaceReferralInvitationDeepLinkDetailDialogTrigger]',
  standalone: true,
})
export class ExpertWorkspaceReferralInvitationDeepLinkDetailDialogTriggerDirective {
  @Output() byClose = new EventEmitter<void>();

  constructor(private dialog: MatDialog) {}

  @HostListener('click', ['$event'])
  public onClick(event: Event): void {
    event.preventDefault();
    const dialogRef = this.dialog.open(
      ExpertWorkspaceReferralInvitationDeepLinkDetailDialogComponent,
      {
        minWidth: '600px',
        maxWidth: '600px',
        panelClass: 'custom-dialog-container',
        disableClose: true,
      }
    );

    dialogRef.afterClosed().subscribe(() => {
      this.byClose.emit();
    });
  }
}
